import { SelectItemType } from 'types/common';

export function chageLocalText(
  localTexts: SelectItemType[],
  text: string,
  setLocalTexts: (text: SelectItemType[]) => void
) {
  const texts = [...localTexts]; // 기존 배열 복사

  // 중복 여부 확인
  const isDuplicate = texts.some((item) => item.value === text);
  if (!isDuplicate) {
    texts.push({
      label: text,
      value: text
    });
    setLocalTexts(texts);
  }
}
